
// // import React, { useState, useEffect } from 'react';
// // import {
// //   Table,
// //   Button,
// //   Modal,
// //   Form,
// //   Input,
// //   InputNumber,
// //   Switch,
// //   Select,
// //   Tag,
// //   Space,
// //   message,
// //   Popconfirm,
// //   Card,
// //   Row,
// //   Col,
// //   Divider,
// //   Typography,
// //   Slider,
// //   Alert
// // } from 'antd';
// // import {
// //   PlusOutlined,
// //   EditOutlined,
// //   DeleteOutlined,
// //   EyeOutlined,
// //   CloseOutlined,
// //   PercentageOutlined
// // } from '@ant-design/icons';
// // import courseService from '../../services/course.service';

// // const { Title, Text } = Typography;
// // const { Option } = Select;

// // const PlanManager = () => {
// //   const [plans, setPlans] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [modalVisible, setModalVisible] = useState(false);
// //   const [editingPlan, setEditingPlan] = useState(null);
// //   const [form] = Form.useForm();
// //   const [features, setFeatures] = useState([]);
// //   const [newFeature, setNewFeature] = useState('');
// //   const [discountValue, setDiscountValue] = useState(0);
// //   const [submitting, setSubmitting] = useState(false);

// //   // Couleurs prédéfinies pour les plans
// //   const colorOptions = [
// //     '#0066b3', '#1890ff', '#52c41a', '#fa8c16', 
// //     '#f5222d', '#722ed1', '#eb2f96', '#13c2c2'
// //   ];

// //   // Devises disponibles
// //   const currencyOptions = ['$', '€', 'MAD', 'USD', 'EUR'];

// //   // Périodes disponibles
// //   const periodOptions = ['/mois', '/trimestre', '/semestre', '/an'];

// //   // Valeurs de réduction communes
// //   const commonDiscounts = [0, 5, 10, 15, 20, 25, 30];

// //   useEffect(() => {
// //     fetchPlans();
// //   }, []);

// //   const fetchPlans = async () => {
// //     setLoading(true);
// //     try {
// //       const response = await courseService.getAllPlans();
// //       setPlans(response);
// //     } catch (error) {
// //       message.error('Erreur lors du chargement des plans');
// //       console.error(error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleCreate = () => {
// //     setEditingPlan(null);
// //     form.resetFields();
// //     setFeatures([]);
// //     setDiscountValue(0);
// //     setSubmitting(false);
// //     setModalVisible(true);
// //   };

// //   const handleEdit = (plan) => {
// //     setEditingPlan(plan);
// //     setSubmitting(false); // Réinitialiser l'état de soumission
// //     const discountRate = (plan.annualDiscountRate || 0) * 100;
// //     form.setFieldsValue({
// //       title: plan.title,
// //       currency: plan.currency,
// //       period: plan.period,
// //       phone: plan.phone,
// //       color: plan.color,
// //       isNew: plan.isNew,
// //       price: plan.price,
// //       annualDiscountRate: discountRate
// //     });
// //     setDiscountValue(discountRate);
// //     setFeatures(plan.features || []);
// //     setModalVisible(true);
// //   };

// //   const handleDelete = async (id) => {
// //     try {
// //       await courseService.deletePlan(id);
// //       message.success('Plan supprimé avec succès');
// //       fetchPlans();
// //     } catch (error) {
// //       message.error('Erreur lors de la suppression');
// //       console.error(error);
// //     }
// //   };

// //   const handleSubmit = async (values) => {
// //     setSubmitting(true);
// //     try {
// //       const planData = {
// //         ...values,
// //         features: features,
// //         annualDiscountRate: (values.annualDiscountRate || 0) / 100 // Convertir le pourcentage en décimal
// //       };

// //       // Délai minimum pour voir le loading
// //       const apiCall = editingPlan 
// //         ? courseService.updatePlan(editingPlan.id, planData)
// //         : courseService.createPlan(planData);
      
// //       const minDelay = new Promise(resolve => setTimeout(resolve, 800)); // 800ms minimum
      
// //       await Promise.all([apiCall, minDelay]);

// //       if (editingPlan) {
// //         message.success('Plan modifié avec succès');
// //       } else {
// //         message.success('Plan créé avec succès');
// //       }

// //       setModalVisible(false);
// //       fetchPlans();
// //     } catch (error) {
// //       message.error('Erreur lors de la sauvegarde');
// //       console.error(error);
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   const handleDiscountChange = (value) => {
// //     setDiscountValue(value);
// //     form.setFieldsValue({ annualDiscountRate: value });
// //   };

// //   const applyCommonDiscount = (discount) => {
// //     setDiscountValue(discount);
// //     form.setFieldsValue({ annualDiscountRate: discount });
// //   };

// //   const calculateDiscountedPrice = () => {
// //     const price = form.getFieldValue('price') || 0;
// //     const discount = discountValue / 100;
// //     const annualPrice = price * 12;
// //     const discountedPrice = annualPrice * (1 - discount);
// //     const savings = annualPrice - discountedPrice;
    
// //     return { annualPrice, discountedPrice, savings };
// //   };

// //   const addFeature = () => {
// //     if (newFeature.trim() && !features.includes(newFeature.trim())) {
// //       setFeatures([...features, newFeature.trim()]);
// //       setNewFeature('');
// //     }
// //   };

// //   const removeFeature = (index) => {
// //     setFeatures(features.filter((_, i) => i !== index));
// //   };

// //   const columns = [
// //     {
// //       title: 'Titre',
// //       dataIndex: 'title',
// //       key: 'title',
// //       render: (text, record) => (
// //         <Space>
// //           <div
// //             style={{
// //               width: 12,
// //               height: 12,
// //               backgroundColor: record.color,
// //               borderRadius: '50%'
// //             }}
// //           />
// //           <strong>{text}</strong>
// //           {record.isNew && <Tag color="red">NEW</Tag>}
// //         </Space>
// //       )
// //     },
// //     {
// //       title: 'Prix',
// //       dataIndex: 'price',
// //       key: 'price',
// //       render: (price, record) => (
// //         <Text strong style={{ color: record.color }}>
// //           {record.currency}{new Intl.NumberFormat('fr-FR').format(price)} {record.period}
// //         </Text>
// //       )
// //     },
// //     {
// //       title: 'Téléphone',
// //       dataIndex: 'phone',
// //       key: 'phone'
// //     },
// //     {
// //       title: 'Remise annuelle',
// //       dataIndex: 'annualDiscountRate',
// //       key: 'annualDiscountRate',
// //       render: (rate) => rate > 0 ? `${(rate * 100).toFixed(1)}%` : '-'
// //     },
// //     {
// //       title: 'Features',
// //       dataIndex: 'features',
// //       key: 'features',
// //       render: (features) => (
// //         <div>
// //           {features?.length > 0 ? (
// //             <Text type="secondary">{features.length} fonctionnalité(s)</Text>
// //           ) : (
// //             <Text type="secondary">Aucune</Text>
// //           )}
// //         </div>
// //       )
// //     },
// //     {
// //       title: 'Actions',
// //       key: 'actions',
// //       width: 120,
// //       render: (_, record) => (
// //         <Space>
// //           <Button
// //             type="primary"
// //             size="small"
// //             icon={<EditOutlined />}
// //             onClick={() => handleEdit(record)}
// //           />
// //           <Popconfirm
// //             title="Supprimer ce plan ?"
// //             description="Cette action est irréversible."
// //             onConfirm={() => handleDelete(record.id)}
// //             okText="Oui"
// //             cancelText="Non"
// //             okType="danger"
// //           >
// //             <Button
// //               danger
// //               size="small"
// //               icon={<DeleteOutlined />}
// //             />
// //           </Popconfirm>
// //         </Space>
// //       )
// //     }
// //   ];

// //   return (
// //     <div style={{ padding: '20px' }}>
// //       <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
// //         <Title level={3}>Gestion des Plans Dédiés</Title>
// //         <Button
// //           type="primary"
// //           icon={<PlusOutlined />}
// //           onClick={handleCreate}
// //         >
// //           Nouveau Plan
// //         </Button>
// //       </div>

// //       <Table
// //         columns={columns}
// //         dataSource={plans}
// //         rowKey="id"
// //         loading={loading}
// //         pagination={{ pageSize: 10 }}
// //       />

// //       <Modal
// //         title={editingPlan ? 'Modifier le Plan' : 'Nouveau Plan'}
// //         open={modalVisible}
// //         onCancel={() => {
// //           setModalVisible(false);
// //           setSubmitting(false);
// //         }}
// //         footer={null}
// //         width={800}
// //         maskClosable={!submitting}
// //         closable={!submitting}
// //       >
// //         <Form
// //           form={form}
// //           layout="vertical"
// //           onFinish={handleSubmit}
// //         >
// //           <Row gutter={16}>
// //             <Col span={12}>
// //               <Form.Item
// //                 name="title"
// //                 label="Titre"
// //                 rules={[{ required: true, message: 'Le titre est obligatoire' }]}
// //               >
// //                 <Input placeholder="Ex: Plan Premium" />
// //               </Form.Item>
// //             </Col>
// //             <Col span={6}>
// //               <Form.Item
// //                 name="currency"
// //                 label="Devise"
// //                 rules={[{ required: true, message: 'La devise est obligatoire' }]}
// //               >
// //                 <Select placeholder="Sélectionner">
// //                   {currencyOptions.map(currency => (
// //                     <Option key={currency} value={currency}>{currency}</Option>
// //                   ))}
// //                 </Select>
// //               </Form.Item>
// //             </Col>
// //             <Col span={6}>
// //               <Form.Item
// //                 name="period"
// //                 label="Période"
// //                 rules={[{ required: true, message: 'La période est obligatoire' }]}
// //               >
// //                 <Select placeholder="Sélectionner">
// //                   {periodOptions.map(period => (
// //                     <Option key={period} value={period}>{period}</Option>
// //                   ))}
// //                 </Select>
// //               </Form.Item>
// //             </Col>
// //           </Row>

// //           <Row gutter={16}>
// //             <Col span={8}>
// //               <Form.Item
// //                 name="price"
// //                 label="Prix"
// //                 rules={[{ required: true, message: 'Le prix est obligatoire' }]}
// //               >
// //                 <InputNumber
// //                   style={{ width: '100%' }}
// //                   min={0}
// //                   step={0.01}
// //                   precision={2}
// //                   placeholder="0.00"
// //                 />
// //               </Form.Item>
// //             </Col>
// //             <Col span={8}>
// //               <Form.Item
// //                 name="phone"
// //                 label="Téléphone"
// //                 rules={[{ required: true, message: 'Le téléphone est obligatoire' }]}
// //               >
// //                 <Input placeholder="+33 1 23 45 67 89" />
// //               </Form.Item>
// //             </Col>
// //             <Col span={8}>
// //               <Form.Item
// //                 name="color"
// //                 label="Couleur du thème"
// //                 rules={[{ required: true, message: 'La couleur est obligatoire' }]}
// //               >
// //                 <Select placeholder="Sélectionner une couleur">
// //                   {colorOptions.map(color => (
// //                     <Option key={color} value={color}>
// //                       <div style={{ display: 'flex', alignItems: 'center' }}>
// //                         <div
// //                           style={{
// //                             width: 16,
// //                             height: 16,
// //                             backgroundColor: color,
// //                             borderRadius: '50%',
// //                             marginRight: 8
// //                           }}
// //                         />
// //                         {color}
// //                       </div>
// //                     </Option>
// //                   ))}
// //                 </Select>
// //               </Form.Item>
// //             </Col>
// //           </Row>

// //           <Row gutter={16}>
// //             <Col span={12}>
// //               <Form.Item
// //                 name="isNew"
// //                 label="Nouveau plan"
// //                 valuePropName="checked"
// //               >
// //                 <Switch />
// //               </Form.Item>
// //             </Col>
// //           </Row>

// //           <Divider />

// //           {/* SECTION GESTION DES REMISES ANNUELLES */}
// //           <Card 
// //             size="small" 
// //             title={
// //               <span>
// //                 <PercentageOutlined style={{ color: '#1890ff', marginRight: 8 }} />
// //                 Gestion de la Remise Annuelle
// //               </span>
// //             }
// //             style={{ marginBottom: 16 }}
// //           >
// //             <Form.Item
// //               name="annualDiscountRate"
// //               label="Pourcentage de remise annuelle"
// //             >
// //               <div style={{ marginBottom: 16 }}>
// //                 <div style={{ marginBottom: 12 }}>
// //                   <Text strong>Remises courantes :</Text>
// //                   <div style={{ marginTop: 8 }}>
// //                     <Space wrap>
// //                       {commonDiscounts.map(discount => (
// //                         <Button
// //                           key={discount}
// //                           size="small"
// //                           type={discountValue === discount ? 'primary' : 'default'}
// //                           onClick={() => applyCommonDiscount(discount)}
// //                           style={{
// //                             borderRadius: 16,
// //                             minWidth: 50
// //                           }}
// //                         >
// //                           {discount}%
// //                         </Button>
// //                       ))}
// //                     </Space>
// //                   </div>
// //                 </div>

// //                 <div style={{ marginBottom: 16 }}>
// //                   <Text strong>Réglage précis :</Text>
// //                   <div style={{ padding: '0 8px' }}>
// //                     <Slider
// //                       value={discountValue}
// //                       onChange={handleDiscountChange}
// //                       min={0}
// //                       max={50}
// //                       step={1}
// //                       marks={{
// //                         0: '0%',
// //                         10: '10%',
// //                         20: '20%',
// //                         30: '30%',
// //                         40: '40%',
// //                         50: '50%'
// //                       }}
// //                       tooltip={{
// //                         formatter: (value) => `${value}%`
// //                       }}
// //                     />
// //                   </div>
// //                 </div>

// //                 <InputNumber
// //                   style={{ width: '100%' }}
// //                   value={discountValue}
// //                   onChange={handleDiscountChange}
// //                   min={0}
// //                   max={95}
// //                   step={1}
// //                   precision={1}
// //                   placeholder="0"
// //                   formatter={value => `${value}%`}
// //                   parser={value => value.replace('%', '')}
// //                 />
// //               </div>
// //             </Form.Item>

// //             {/* Aperçu de l'impact de la remise */}
// //             {form.getFieldValue('price') && discountValue > 0 && (
// //               <Alert
// //                 type="info"
// //                 showIcon
// //                 message={
// //                   <div>
// //                     <div><strong>Impact de la remise sur le prix annuel :</strong></div>
// //                     <div style={{ marginTop: 4 }}>
// //                       <Text>Prix annuel normal : </Text>
// //                       <Text delete>
// //                         {form.getFieldValue('currency') || '$'}
// //                         {(form.getFieldValue('price') * 12).toLocaleString('fr-FR')}
// //                       </Text>
// //                     </div>
// //                     <div>
// //                       <Text>Prix avec remise : </Text>
// //                       <Text strong style={{ color: '#52c41a' }}>
// //                         {form.getFieldValue('currency') || '$'}
// //                         {calculateDiscountedPrice().discountedPrice.toLocaleString('fr-FR')}
// //                       </Text>
// //                     </div>
// //                     <div>
// //                       <Text>Économie : </Text>
// //                       <Text strong style={{ color: '#fa541c' }}>
// //                         {form.getFieldValue('currency') || '$'}
// //                         {calculateDiscountedPrice().savings.toLocaleString('fr-FR')}
// //                       </Text>
// //                     </div>
// //                   </div>
// //                 }
// //                 style={{ marginTop: 12 }}
// //               />
// //             )}
// //           </Card>

// //           <div style={{ marginBottom: '16px' }}>
// //             <Title level={5}>Fonctionnalités</Title>
// //             <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
// //               <Input
// //                 value={newFeature}
// //                 onChange={(e) => setNewFeature(e.target.value)}
// //                 placeholder="Ajouter une fonctionnalité"
// //                 onPressEnter={addFeature}
// //               />
// //               <Button
// //                 type="primary"
// //                 icon={<PlusOutlined />}
// //                 onClick={addFeature}
// //                 disabled={!newFeature.trim()}
// //               />
// //             </div>
// //             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
// //               {features.map((feature, index) => (
// //                 <Tag
// //                   key={index}
// //                   closable
// //                   onClose={() => removeFeature(index)}
// //                   style={{ marginBottom: '4px' }}
// //                 >
// //                   {feature}
// //                 </Tag>
// //               ))}
// //             </div>
// //           </div>

// //           <div style={{ textAlign: 'right', marginTop: '24px' }}>
// //             <Space>
// //               <Button 
// //                 onClick={() => setModalVisible(false)}
// //                 disabled={submitting}
// //               >
// //                 Annuler
// //               </Button>
// //               <Button 
// //                 type="primary" 
// //                 htmlType="submit"
// //                 loading={submitting}
// //                 disabled={submitting}
// //               >
// //                 {editingPlan ? 'Modifier' : 'Créer'}
// //               </Button>
// //             </Space>
// //           </div>
// //         </Form>
// //       </Modal>
// //     </div>
// //   );
// // };

// // export default PlanManager;


// import React, { useState, useEffect } from 'react';
// import {
//   Table,
//   Button,
//   Modal,
//   Form,
//   Input,
//   InputNumber,
//   Switch,
//   Select,
//   Tag,
//   Space,
//   message,
//   Popconfirm,
//   Card,
//   Row,
//   Col,
//   Divider,
//   Typography,
//   Slider,
//   Alert,
//   Tooltip,
//   Badge
// } from 'antd';
// import {
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   EyeOutlined,
//   EyeInvisibleOutlined,
//   CloseOutlined,
//   PercentageOutlined,
//   CheckCircleOutlined,
//   StopOutlined
// } from '@ant-design/icons';
// import courseService from '../../services/course.service';

// const { Title, Text } = Typography;
// const { Option } = Select;

// const PlanManager = () => {
//   const [plans, setPlans] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [editingPlan, setEditingPlan] = useState(null);
//   const [form] = Form.useForm();
//   const [features, setFeatures] = useState([]);
//   const [newFeature, setNewFeature] = useState('');
//   const [discountValue, setDiscountValue] = useState(0);
//   const [submitting, setSubmitting] = useState(false);
//   const [togglingIds, setTogglingIds] = useState(new Set()); // ✅ Track les plans en cours de toggle
// const [bulkLoading, setBulkLoading] = useState(false);
//   // Couleurs prédéfinies pour les plans
//   const colorOptions = [
//     '#0066b3', '#1890ff', '#52c41a', '#fa8c16', 
//     '#f5222d', '#722ed1', '#eb2f96', '#13c2c2'
//   ];

//   // Devises disponibles
//   const currencyOptions = ['$', '€', 'MAD', 'USD', 'EUR'];

//   // Périodes disponibles
//   const periodOptions = ['/mois', '/trimestre', '/semestre', '/an'];

//   // Valeurs de réduction communes
//   const commonDiscounts = [0, 5, 10, 15, 20, 25, 30];
// const handleHideAll = async () => {
//   setBulkLoading(true);
//   try {
//     await courseService.hideAllPlans();
//     message.success('Tous les plans ont été masqués');
//     fetchPlans();
//   } catch (error) {
//     message.error('Erreur lors du masquage');
//   } finally {
//     setBulkLoading(false);
//   }
// };

// const handleShowAll = async () => {
//   setBulkLoading(true);
//   try {
//     const allIds = plans.map(p => p.id);
//     await courseService.setDisplayedPlans(allIds);
//     message.success('Tous les plans sont maintenant affichés');
//     fetchPlans();
//   } catch (error) {
//     message.error("Erreur lors de l'affichage");
//   } finally {
//     setBulkLoading(false);
//   }
// };
//   useEffect(() => {
//     fetchPlans();
//   }, []);

//   const fetchPlans = async () => {
//     setLoading(true);
//     try {
//       const response = await courseService.getAllPlans();
//       setPlans(response);
//     } catch (error) {
//       message.error('Erreur lors du chargement des plans');
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCreate = () => {
//     setEditingPlan(null);
//     form.resetFields();
//     // ✅ Définir displayed=true par défaut pour les nouveaux plans
//     form.setFieldsValue({ displayed: true });
//     setFeatures([]);
//     setDiscountValue(0);
//     setSubmitting(false);
//     setModalVisible(true);
//   };

//   const handleEdit = (plan) => {
//     setEditingPlan(plan);
//     setSubmitting(false);
//     const discountRate = (plan.annualDiscountRate || 0) * 100;
//     form.setFieldsValue({
//       title: plan.title,
//       currency: plan.currency,
//       period: plan.period,
//       phone: plan.phone,
//       color: plan.color,
//       isNew: plan.isNew,
//       price: plan.price,
//       annualDiscountRate: discountRate,
//       displayed: plan.displayed !== false // ✅ NOUVEAU : charger l'état d'affichage
//     });
//     setDiscountValue(discountRate);
//     setFeatures(plan.features || []);
//     setModalVisible(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       await courseService.deletePlan(id);
//       message.success('Plan supprimé avec succès');
//       fetchPlans();
//     } catch (error) {
//       message.error('Erreur lors de la suppression');
//       console.error(error);
//     }
//   };

//   // ✅ NOUVEAU : Toggle visibilité rapide depuis le tableau
//   const handleToggleDisplayed = async (planId) => {
//     setTogglingIds(prev => new Set(prev).add(planId));
//     try {
//       const response = await courseService.togglePlanDisplayed(planId);
      
//       // Mise à jour optimiste locale (sans recharger tout le tableau)
//       setPlans(prev => prev.map(p => 
//         p.id === planId 
//           ? { ...p, displayed: response.displayed }
//           : p
//       ));
      
//       message.success(response.message || (
//         response.displayed 
//           ? 'Plan affiché dans l\'interface publique' 
//           : 'Plan masqué de l\'interface publique'
//       ));
//     } catch (error) {
//       message.error('Erreur lors de la modification de la visibilité');
//       console.error(error);
//     } finally {
//       setTogglingIds(prev => {
//         const next = new Set(prev);
//         next.delete(planId);
//         return next;
//       });
//     }
//   };

//   const handleSubmit = async (values) => {
//     setSubmitting(true);
//     try {
//       const planData = {
//         ...values,
//         features: features,
//         annualDiscountRate: (values.annualDiscountRate || 0) / 100,
//         displayed: values.displayed !== false // ✅ NOUVEAU : inclure displayed
//       };

//       const apiCall = editingPlan 
//         ? courseService.updatePlan(editingPlan.id, planData)
//         : courseService.createPlan(planData);
      
//       const minDelay = new Promise(resolve => setTimeout(resolve, 800));
      
//       await Promise.all([apiCall, minDelay]);

//       if (editingPlan) {
//         message.success('Plan modifié avec succès');
//       } else {
//         message.success('Plan créé avec succès');
//       }

//       setModalVisible(false);
//       fetchPlans();
//     } catch (error) {
//       message.error('Erreur lors de la sauvegarde');
//       console.error(error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleDiscountChange = (value) => {
//     setDiscountValue(value);
//     form.setFieldsValue({ annualDiscountRate: value });
//   };

//   const applyCommonDiscount = (discount) => {
//     setDiscountValue(discount);
//     form.setFieldsValue({ annualDiscountRate: discount });
//   };

//   const calculateDiscountedPrice = () => {
//     const price = form.getFieldValue('price') || 0;
//     const discount = discountValue / 100;
//     const annualPrice = price * 12;
//     const discountedPrice = annualPrice * (1 - discount);
//     const savings = annualPrice - discountedPrice;
    
//     return { annualPrice, discountedPrice, savings };
//   };

//   const addFeature = () => {
//     if (newFeature.trim() && !features.includes(newFeature.trim())) {
//       setFeatures([...features, newFeature.trim()]);
//       setNewFeature('');
//     }
//   };

//   const removeFeature = (index) => {
//     setFeatures(features.filter((_, i) => i !== index));
//   };

//   // ✅ Stats rapides
//   const displayedCount = plans.filter(p => p.displayed !== false).length;
//   const hiddenCount = plans.filter(p => p.displayed === false).length;

//   const columns = [
//     {
//       title: 'Titre',
//       dataIndex: 'title',
//       key: 'title',
//       render: (text, record) => (
//         <Space>
//           <div
//             style={{
//               width: 12,
//               height: 12,
//               backgroundColor: record.color,
//               borderRadius: '50%'
//             }}
//           />
//           <strong style={{ 
//             color: record.displayed === false ? '#bbb' : 'inherit',
//           }}>
//             {text}
//           </strong>
//           {record.isNew && <Tag color="red">NEW</Tag>}
//           {record.displayed === false && (
//             <Tag color="default" style={{ borderStyle: 'dashed' }}>
//               <EyeInvisibleOutlined style={{ marginRight: 4 }} />
//               Masqué
//             </Tag>
//           )}
//         </Space>
//       )
//     },
//     {
//       title: 'Prix',
//       dataIndex: 'price',
//       key: 'price',
//       render: (price, record) => (
//         <Text strong style={{ color: record.displayed === false ? '#bbb' : record.color }}>
//           {record.currency}{new Intl.NumberFormat('fr-FR').format(price)} {record.period}
//         </Text>
//       )
//     },
//     {
//       title: 'Téléphone',
//       dataIndex: 'phone',
//       key: 'phone'
//     },
//     {
//       title: 'Remise annuelle',
//       dataIndex: 'annualDiscountRate',
//       key: 'annualDiscountRate',
//       render: (rate) => rate > 0 ? `${(rate * 100).toFixed(1)}%` : '-'
//     },
//     {
//       title: 'Features',
//       dataIndex: 'features',
//       key: 'features',
//       render: (features) => (
//         <div>
//           {features?.length > 0 ? (
//             <Text type="secondary">{features.length} fonctionnalité(s)</Text>
//           ) : (
//             <Text type="secondary">Aucune</Text>
//           )}
//         </div>
//       )
//     },
//     // ✅ NOUVELLE COLONNE : Visibilité
//     {
//       title: 'Visibilité',
//       dataIndex: 'displayed',
//       key: 'displayed',
//       width: 130,
//       align: 'center',
//       filters: [
//         { text: 'Affiché', value: true },
//         { text: 'Masqué', value: false },
//       ],
//       onFilter: (value, record) => (record.displayed !== false) === value,
//       render: (displayed, record) => (
//         <Tooltip 
//           title={displayed !== false 
//             ? "Ce plan est visible — cliquez pour masquer" 
//             : "Ce plan est masqué — cliquez pour afficher"
//           }
//         >
//           <Switch
//             checked={displayed !== false}
//             loading={togglingIds.has(record.id)}
//             onChange={() => handleToggleDisplayed(record.id)}
//             checkedChildren={<EyeOutlined />}
//             unCheckedChildren={<EyeInvisibleOutlined />}
//             style={{
//               backgroundColor: displayed !== false ? '#52c41a' : '#d9d9d9',
//             }}
//           />
//         </Tooltip>
//       )
//     },
//     {
//       title: 'Actions',
//       key: 'actions',
//       width: 120,
//       render: (_, record) => (
//         <Space>
//           <Button
//             type="primary"
//             size="small"
//             icon={<EditOutlined />}
//             onClick={() => handleEdit(record)}
//           />
//           <Popconfirm
//             title="Supprimer ce plan ?"
//             description="Cette action est irréversible."
//             onConfirm={() => handleDelete(record.id)}
//             okText="Oui"
//             cancelText="Non"
//             okType="danger"
//           >
//             <Button
//               danger
//               size="small"
//               icon={<DeleteOutlined />}
//             />
//           </Popconfirm>
//         </Space>
//       )
//     }
//   ];

//   return (
//     <div style={{ padding: '20px' }}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//        <Space wrap>
//   <Popconfirm
//     title="Masquer tous les plans ?"
//     description={<span>Tous les {plans.length} plans seront masqués.<br/>Vous pourrez ensuite choisir lesquels afficher.</span>}
//     onConfirm={handleHideAll}
//     okText="Tout masquer"
//     cancelText="Annuler"
//     okType="danger"
//   >
//     <Button
//       icon={<EyeInvisibleOutlined />}
//       loading={bulkLoading}
//       disabled={hiddenCount === plans.length}
//     >
//       Tout masquer
//     </Button>
//   </Popconfirm>

//   <Popconfirm
//     title="Afficher tous les plans ?"
//     description={`Les ${plans.length} plans seront visibles.`}
//     onConfirm={handleShowAll}
//     okText="Tout afficher"
//     cancelText="Annuler"
//   >
//     <Button
//       icon={<EyeOutlined />}
//       loading={bulkLoading}
//       disabled={displayedCount === plans.length}
//     >
//       Tout afficher
//     </Button>
//   </Popconfirm>

//   <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
//     Nouveau Plan
//   </Button>
// </Space>
//       </div>

//       <Table
//         columns={columns}
//         dataSource={plans}
//         rowKey="id"
//         loading={loading}
//         pagination={{ pageSize: 10 }}
//         rowClassName={(record) => 
//           record.displayed === false ? 'plan-hidden-row' : ''
//         }
//       />

//       {/* ✅ Style pour les lignes masquées */}
//       <style>{`
//         .plan-hidden-row {
//           background-color: #fafafa !important;
//           opacity: 0.7;
//         }
//         .plan-hidden-row:hover {
//           opacity: 1;
//         }
//       `}</style>

//       <Modal
//         title={editingPlan ? 'Modifier le Plan' : 'Nouveau Plan'}
//         open={modalVisible}
//         onCancel={() => {
//           setModalVisible(false);
//           setSubmitting(false);
//         }}
//         footer={null}
//         width={800}
//         maskClosable={!submitting}
//         closable={!submitting}
//       >
//         <Form
//           form={form}
//           layout="vertical"
//           onFinish={handleSubmit}
//         >
//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 name="title"
//                 label="Titre"
//                 rules={[{ required: true, message: 'Le titre est obligatoire' }]}
//               >
//                 <Input placeholder="Ex: Plan Premium" />
//               </Form.Item>
//             </Col>
//             <Col span={6}>
//               <Form.Item
//                 name="currency"
//                 label="Devise"
//                 rules={[{ required: true, message: 'La devise est obligatoire' }]}
//               >
//                 <Select placeholder="Sélectionner">
//                   {currencyOptions.map(currency => (
//                     <Option key={currency} value={currency}>{currency}</Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col>
//             <Col span={6}>
//               <Form.Item
//                 name="period"
//                 label="Période"
//                 rules={[{ required: true, message: 'La période est obligatoire' }]}
//               >
//                 <Select placeholder="Sélectionner">
//                   {periodOptions.map(period => (
//                     <Option key={period} value={period}>{period}</Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row gutter={16}>
//             <Col span={8}>
//               <Form.Item
//                 name="price"
//                 label="Prix"
//                 rules={[{ required: true, message: 'Le prix est obligatoire' }]}
//               >
//                 <InputNumber
//                   style={{ width: '100%' }}
//                   min={0}
//                   step={0.01}
//                   precision={2}
//                   placeholder="0.00"
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={8}>
//               <Form.Item
//                 name="phone"
//                 label="Téléphone"
//                 rules={[{ required: true, message: 'Le téléphone est obligatoire' }]}
//               >
//                 <Input placeholder="+33 1 23 45 67 89" />
//               </Form.Item>
//             </Col>
//             <Col span={8}>
//               <Form.Item
//                 name="color"
//                 label="Couleur du thème"
//                 rules={[{ required: true, message: 'La couleur est obligatoire' }]}
//               >
//                 <Select placeholder="Sélectionner une couleur">
//                   {colorOptions.map(color => (
//                     <Option key={color} value={color}>
//                       <div style={{ display: 'flex', alignItems: 'center' }}>
//                         <div
//                           style={{
//                             width: 16,
//                             height: 16,
//                             backgroundColor: color,
//                             borderRadius: '50%',
//                             marginRight: 8
//                           }}
//                         />
//                         {color}
//                       </div>
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col>
//           </Row>

//           {/* ✅ NOUVEAU : Ligne avec les switches */}
//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 name="isNew"
//                 label="Nouveau plan"
//                 valuePropName="checked"
//               >
//                 <Switch />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="displayed"
//                 label={
//                   <Space>
//                     Affiché dans l'interface publique
//                     <Tooltip title="Si désactivé, ce plan ne sera pas visible par les utilisateurs sur le site. Il restera accessible uniquement dans le panneau d'administration.">
//                       <span style={{ 
//                         width: 16, height: 16, borderRadius: '50%', 
//                         background: '#f0f0f0', display: 'inline-flex', 
//                         alignItems: 'center', justifyContent: 'center',
//                         fontSize: 11, color: '#999', cursor: 'help'
//                       }}>
//                         ?
//                       </span>
//                     </Tooltip>
//                   </Space>
//                 }
//                 valuePropName="checked"
//               >
//                 <Switch 
//                   checkedChildren={<><EyeOutlined /> Visible</>}
//                   unCheckedChildren={<><EyeInvisibleOutlined /> Masqué</>}
//                   style={{ minWidth: 100 }}
//                 />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Divider />

//           {/* SECTION GESTION DES REMISES ANNUELLES */}
//           <Card 
//             size="small" 
//             title={
//               <span>
//                 <PercentageOutlined style={{ color: '#1890ff', marginRight: 8 }} />
//                 Gestion de la Remise Annuelle
//               </span>
//             }
//             style={{ marginBottom: 16 }}
//           >
//             <Form.Item
//               name="annualDiscountRate"
//               label="Pourcentage de remise annuelle"
//             >
//               <div style={{ marginBottom: 16 }}>
//                 <div style={{ marginBottom: 12 }}>
//                   <Text strong>Remises courantes :</Text>
//                   <div style={{ marginTop: 8 }}>
//                     <Space wrap>
//                       {commonDiscounts.map(discount => (
//                         <Button
//                           key={discount}
//                           size="small"
//                           type={discountValue === discount ? 'primary' : 'default'}
//                           onClick={() => applyCommonDiscount(discount)}
//                           style={{
//                             borderRadius: 16,
//                             minWidth: 50
//                           }}
//                         >
//                           {discount}%
//                         </Button>
//                       ))}
//                     </Space>
//                   </div>
//                 </div>

//                 <div style={{ marginBottom: 16 }}>
//                   <Text strong>Réglage précis :</Text>
//                   <div style={{ padding: '0 8px' }}>
//                     <Slider
//                       value={discountValue}
//                       onChange={handleDiscountChange}
//                       min={0}
//                       max={50}
//                       step={1}
//                       marks={{
//                         0: '0%',
//                         10: '10%',
//                         20: '20%',
//                         30: '30%',
//                         40: '40%',
//                         50: '50%'
//                       }}
//                       tooltip={{
//                         formatter: (value) => `${value}%`
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <InputNumber
//                   style={{ width: '100%' }}
//                   value={discountValue}
//                   onChange={handleDiscountChange}
//                   min={0}
//                   max={95}
//                   step={1}
//                   precision={1}
//                   placeholder="0"
//                   formatter={value => `${value}%`}
//                   parser={value => value.replace('%', '')}
//                 />
//               </div>
//             </Form.Item>

//             {/* Aperçu de l'impact de la remise */}
//             {form.getFieldValue('price') && discountValue > 0 && (
//               <Alert
//                 type="info"
//                 showIcon
//                 message={
//                   <div>
//                     <div><strong>Impact de la remise sur le prix annuel :</strong></div>
//                     <div style={{ marginTop: 4 }}>
//                       <Text>Prix annuel normal : </Text>
//                       <Text delete>
//                         {form.getFieldValue('currency') || '$'}
//                         {(form.getFieldValue('price') * 12).toLocaleString('fr-FR')}
//                       </Text>
//                     </div>
//                     <div>
//                       <Text>Prix avec remise : </Text>
//                       <Text strong style={{ color: '#52c41a' }}>
//                         {form.getFieldValue('currency') || '$'}
//                         {calculateDiscountedPrice().discountedPrice.toLocaleString('fr-FR')}
//                       </Text>
//                     </div>
//                     <div>
//                       <Text>Économie : </Text>
//                       <Text strong style={{ color: '#fa541c' }}>
//                         {form.getFieldValue('currency') || '$'}
//                         {calculateDiscountedPrice().savings.toLocaleString('fr-FR')}
//                       </Text>
//                     </div>
//                   </div>
//                 }
//                 style={{ marginTop: 12 }}
//               />
//             )}
//           </Card>

//           <div style={{ marginBottom: '16px' }}>
//             <Title level={5}>Fonctionnalités</Title>
//             <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
//               <Input
//                 value={newFeature}
//                 onChange={(e) => setNewFeature(e.target.value)}
//                 placeholder="Ajouter une fonctionnalité"
//                 onPressEnter={addFeature}
//               />
//               <Button
//                 type="primary"
//                 icon={<PlusOutlined />}
//                 onClick={addFeature}
//                 disabled={!newFeature.trim()}
//               />
//             </div>
//             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
//               {features.map((feature, index) => (
//                 <Tag
//                   key={index}
//                   closable
//                   onClose={() => removeFeature(index)}
//                   style={{ marginBottom: '4px' }}
//                 >
//                   {feature}
//                 </Tag>
//               ))}
//             </div>
//           </div>

//           <div style={{ textAlign: 'right', marginTop: '24px' }}>
//             <Space>
//               <Button 
//                 onClick={() => setModalVisible(false)}
//                 disabled={submitting}
//               >
//                 Annuler
//               </Button>
//               <Button 
//                 type="primary" 
//                 htmlType="submit"
//                 loading={submitting}
//                 disabled={submitting}
//               >
//                 {editingPlan ? 'Modifier' : 'Créer'}
//               </Button>
//             </Space>
//           </div>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default PlanManager;

import React, { useState, useEffect, useMemo } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Switch,
  Select,
  Tag,
  Space,
  message,
  Popconfirm,
  Card,
  Row,
  Col,
  Divider,
  Typography,
  Slider,
  Alert,
  Tooltip,
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  PercentageOutlined,
  SearchOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import courseService from '../../services/course.service';

const { Title, Text } = Typography;
const { Option } = Select;

const PlanManager = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [form] = Form.useForm();
  const [features, setFeatures] = useState([]);
  const [newFeature, setNewFeature] = useState('');
  const [discountValue, setDiscountValue] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [togglingIds, setTogglingIds] = useState(new Set());
  const [bulkLoading, setBulkLoading] = useState(false);
  const [searchText, setSearchText] = useState(''); // ✅ Recherche par mot-clé

  const colorOptions = [
    '#0066b3', '#1890ff', '#52c41a', '#fa8c16',
    '#f5222d', '#722ed1', '#eb2f96', '#13c2c2',
  ];
  const currencyOptions = ['$', '€', 'MAD', 'USD', 'EUR'];
  const periodOptions = ['/mois', '/trimestre', '/semestre', '/an'];
  const commonDiscounts = [0, 5, 10, 15, 20, 25, 30];

  useEffect(() => { fetchPlans(); }, []);

  const fetchPlans = async () => {
    setLoading(true);
    try {
      const response = await courseService.getAllPlans();
      setPlans(response);
    } catch (error) {
      message.error('Erreur lors du chargement des plans');
    } finally {
      setLoading(false);
    }
  };

  // ✅ Plans filtrés par recherche
  const filteredPlans = useMemo(() => {
    if (!searchText.trim()) return plans;
    const q = searchText.toLowerCase().trim();
    return plans.filter(p =>
      (p.title || '').toLowerCase().includes(q) ||
      (p.phone || '').toLowerCase().includes(q) ||
      (p.currency || '').toLowerCase().includes(q) ||
      (p.features || []).some(f => f.toLowerCase().includes(q))
    );
  }, [plans, searchText]);

  // ── BULK ACTIONS ──

  const handleHideAll = async () => {
    setBulkLoading(true);
    try {
      await courseService.hideAllPlans();
      message.success('Tous les plans ont été masqués de la page Home');
      fetchPlans();
    } catch (error) {
      message.error('Erreur lors du masquage');
    } finally {
      setBulkLoading(false);
    }
  };

  const handleShowAll = async () => {
    setBulkLoading(true);
    try {
      const allIds = plans.map(p => p.id);
      await courseService.setDisplayedPlans(allIds);
      message.success('Tous les plans sont maintenant affichés sur la page Home');
      fetchPlans();
    } catch (error) {
      message.error("Erreur lors de l'affichage");
    } finally {
      setBulkLoading(false);
    }
  };

  // ── TOGGLE SINGLE ──

  const handleToggleDisplayed = async (planId) => {
    setTogglingIds(prev => new Set(prev).add(planId));
    try {
      const response = await courseService.togglePlanDisplayed(planId);
      setPlans(prev =>
        prev.map(p => (p.id === planId ? { ...p, displayed: response.displayed } : p))
      );
      message.success(
        response.displayed
          ? 'Plan visible sur la page Home'
          : 'Plan masqué de la page Home'
      );
    } catch (error) {
      message.error('Erreur lors de la modification');
    } finally {
      setTogglingIds(prev => { const n = new Set(prev); n.delete(planId); return n; });
    }
  };

  // ── CRUD ──

  const handleCreate = () => {
    setEditingPlan(null);
    form.resetFields();
    form.setFieldsValue({ displayed: true });
    setFeatures([]);
    setDiscountValue(0);
    setSubmitting(false);
    setModalVisible(true);
  };

  const handleEdit = (plan) => {
    setEditingPlan(plan);
    setSubmitting(false);
    const discountRate = (plan.annualDiscountRate || 0) * 100;
    form.setFieldsValue({
      title: plan.title,
      currency: plan.currency,
      period: plan.period,
      phone: plan.phone,
      color: plan.color,
      isNew: plan.isNew,
      price: plan.price,
      annualDiscountRate: discountRate,
      displayed: plan.displayed !== false,
    });
    setDiscountValue(discountRate);
    setFeatures(plan.features || []);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await courseService.deletePlan(id);
      message.success('Plan supprimé avec succès');
      fetchPlans();
    } catch (error) {
      message.error('Erreur lors de la suppression');
    }
  };

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      const planData = {
        ...values,
        features,
        annualDiscountRate: (values.annualDiscountRate || 0) / 100,
        displayed: values.displayed !== false,
      };
      const apiCall = editingPlan
        ? courseService.updatePlan(editingPlan.id, planData)
        : courseService.createPlan(planData);
      const minDelay = new Promise(r => setTimeout(r, 800));
      await Promise.all([apiCall, minDelay]);
      message.success(editingPlan ? 'Plan modifié' : 'Plan créé');
      setModalVisible(false);
      fetchPlans();
    } catch (error) {
      message.error('Erreur lors de la sauvegarde');
    } finally {
      setSubmitting(false);
    }
  };

  // ── DISCOUNT HELPERS ──

  const handleDiscountChange = (v) => { setDiscountValue(v); form.setFieldsValue({ annualDiscountRate: v }); };
  const applyCommonDiscount = (d) => { setDiscountValue(d); form.setFieldsValue({ annualDiscountRate: d }); };
  const calculateDiscountedPrice = () => {
    const p = form.getFieldValue('price') || 0;
    const d = discountValue / 100;
    const annual = p * 12;
    const discounted = annual * (1 - d);
    return { annualPrice: annual, discountedPrice: discounted, savings: annual - discounted };
  };
  const addFeature = () => {
    if (newFeature.trim() && !features.includes(newFeature.trim())) {
      setFeatures([...features, newFeature.trim()]);
      setNewFeature('');
    }
  };
  const removeFeature = (i) => setFeatures(features.filter((_, idx) => idx !== i));

  // ── STATS ──

  const displayedCount = plans.filter(p => p.displayed !== false).length;
  const hiddenCount = plans.filter(p => p.displayed === false).length;

  // ── COLUMNS ──

  const columns = [
    {
      title: 'Titre',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => (
        <Space>
          <div style={{ width: 12, height: 12, backgroundColor: record.color, borderRadius: '50%' }} />
          <strong style={{ color: record.displayed === false ? '#bbb' : 'inherit' }}>{text}</strong>
          {record.isNew && <Tag color="red">NEW</Tag>}
          {record.displayed === false && (
            <Tag color="default" style={{ borderStyle: 'dashed' }}>
              <EyeInvisibleOutlined style={{ marginRight: 4 }} />
              Masqué de la page Home
            </Tag>
          )}
        </Space>
      ),
    },
    {
      title: 'Prix',
      dataIndex: 'price',
      key: 'price',
      render: (price, record) => (
        <Text strong style={{ color: record.displayed === false ? '#bbb' : record.color }}>
          {record.currency}{new Intl.NumberFormat('fr-FR').format(price)} {record.period}
        </Text>
      ),
    },
    { title: 'Téléphone', dataIndex: 'phone', key: 'phone' },
    {
      title: 'Remise annuelle',
      dataIndex: 'annualDiscountRate',
      key: 'annualDiscountRate',
      render: (rate) => (rate > 0 ? `${(rate * 100).toFixed(1)}%` : '-'),
    },
    {
      title: 'Features',
      dataIndex: 'features',
      key: 'features',
      render: (f) => <Text type="secondary">{f?.length || 0} fonctionnalité(s)</Text>,
    },
    {
      title: (
        <Space size={4}>
          <HomeOutlined style={{ color: '#1890ff' }} />
          <span>Page Home</span>
        </Space>
      ),
      dataIndex: 'displayed',
      key: 'displayed',
      width: 140,
      align: 'center',
      filters: [
        { text: 'Visible sur Home', value: true },
        { text: 'Masqué de Home', value: false },
      ],
      onFilter: (value, record) => (record.displayed !== false) === value,
      render: (displayed, record) => (
        <Tooltip
          title={displayed !== false
            ? 'Visible sur la page Home — cliquez pour masquer'
            : 'Masqué de la page Home — cliquez pour afficher'}
        >
          <Switch
            checked={displayed !== false}
            loading={togglingIds.has(record.id)}
            onChange={() => handleToggleDisplayed(record.id)}
            checkedChildren={<><EyeOutlined /> Visible</>}
            unCheckedChildren={<><EyeInvisibleOutlined /> Masqué</>}
            style={{
              backgroundColor: displayed !== false ? '#52c41a' : '#d9d9d9',
              minWidth: 90,
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 120,
      render: (_, record) => (
        <Space>
          <Button type="primary" size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
          <Popconfirm title="Supprimer ce plan ?" description="Cette action est irréversible."
            onConfirm={() => handleDelete(record.id)} okText="Oui" cancelText="Non" okType="danger">
            <Button danger size="small" icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // ── RENDER ──

  return (
    <div style={{ padding: '20px' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <Title level={3} style={{ margin: 0 }}>Gestion des Plans Dédiés</Title>
          <Space style={{ marginTop: 8 }}>
            <Tag icon={<EyeOutlined />} color="success">
              {displayedCount} visible{displayedCount > 1 ? 's' : ''} sur Home
            </Tag>
            {hiddenCount > 0 && (
              <Tag icon={<EyeInvisibleOutlined />} color="default">
                {hiddenCount} masqué{hiddenCount > 1 ? 's' : ''} de Home
              </Tag>
            )}
            <Tag color="blue">{plans.length} total</Tag>
          </Space>
        </div>

        <Space wrap>
          <Popconfirm
            title="Masquer tous les plans de la page Home ?"
            description={
              <span>
                Les {plans.length} plans seront masqués de la page Home.<br />
                Vous pourrez ensuite choisir lesquels afficher.
              </span>
            }
            onConfirm={handleHideAll}
            okText="Tout masquer"
            cancelText="Annuler"
            okType="danger"
          >
            <Button icon={<EyeInvisibleOutlined />} loading={bulkLoading} disabled={hiddenCount === plans.length}>
              Tout masquer de Home
            </Button>
          </Popconfirm>

          <Popconfirm
            title="Afficher tous les plans sur la page Home ?"
            description={`Les ${plans.length} plans seront visibles sur la page Home.`}
            onConfirm={handleShowAll}
            okText="Tout afficher"
            cancelText="Annuler"
          >
            <Button icon={<EyeOutlined />} loading={bulkLoading} disabled={displayedCount === plans.length}>
              Tout afficher sur Home
            </Button>
          </Popconfirm>

          <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
            Nouveau Plan
          </Button>
        </Space>
      </div>

      {/* ✅ Barre de recherche */}
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="Rechercher un plan par titre, téléphone, devise, fonctionnalité…"
          prefix={<SearchOutlined style={{ color: '#bbb' }} />}
          allowClear
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ maxWidth: 500, borderRadius: 8 }}
          size="middle"
        />
        {searchText && (
          <Text type="secondary" style={{ marginLeft: 12, fontSize: 13 }}>
            {filteredPlans.length} résultat{filteredPlans.length > 1 ? 's' : ''} sur {plans.length}
          </Text>
        )}
      </div>

      {/* Aide quand tout est masqué */}
      {hiddenCount === plans.length && plans.length > 0 && (
        <Alert
          message="Tous les plans sont masqués de la page Home"
          description="Activez le switch dans la colonne « Page Home » pour choisir les plans à afficher aux utilisateurs."
          type="info"
          showIcon
          icon={<HomeOutlined />}
          style={{ marginBottom: 16, borderRadius: 8 }}
        />
      )}

      {/* Table */}
      <Table
        columns={columns}
        dataSource={filteredPlans}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        rowClassName={(record) => record.displayed === false ? 'plan-hidden-row' : ''}
      />

      <style>{`
        .plan-hidden-row { background-color: #fafafa !important; opacity: 0.65; }
        .plan-hidden-row:hover { opacity: 1; }
      `}</style>

      {/* ── MODAL CREATE/EDIT ── */}
      <Modal
        title={editingPlan ? 'Modifier le Plan' : 'Nouveau Plan'}
        open={modalVisible}
        onCancel={() => { setModalVisible(false); setSubmitting(false); }}
        footer={null}
        width={800}
        maskClosable={!submitting}
        closable={!submitting}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="title" label="Titre" rules={[{ required: true, message: 'Obligatoire' }]}>
                <Input placeholder="Ex: Plan Premium" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="currency" label="Devise" rules={[{ required: true, message: 'Obligatoire' }]}>
                <Select placeholder="Sélectionner">
                  {currencyOptions.map(c => <Option key={c} value={c}>{c}</Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="period" label="Période" rules={[{ required: true, message: 'Obligatoire' }]}>
                <Select placeholder="Sélectionner">
                  {periodOptions.map(p => <Option key={p} value={p}>{p}</Option>)}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="price" label="Prix" rules={[{ required: true, message: 'Obligatoire' }]}>
                <InputNumber style={{ width: '100%' }} min={0} step={0.01} precision={2} placeholder="0.00" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="phone" label="Téléphone" rules={[{ required: true, message: 'Obligatoire' }]}>
                <Input placeholder="+33 1 23 45 67 89" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="color" label="Couleur du thème" rules={[{ required: true, message: 'Obligatoire' }]}>
                <Select placeholder="Sélectionner">
                  {colorOptions.map(c => (
                    <Option key={c} value={c}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: 16, height: 16, backgroundColor: c, borderRadius: '50%', marginRight: 8 }} />
                        {c}
                      </div>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="isNew" label="Nouveau plan" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="displayed"
                label={
                  <Space>
                    <HomeOutlined style={{ color: '#1890ff' }} />
                    Visible sur la page Home
                    <Tooltip title="Si désactivé, ce plan ne sera pas visible par les utilisateurs sur la page d'accueil. Il restera accessible uniquement ici dans l'administration.">
                      <span style={{
                        width: 16, height: 16, borderRadius: '50%', background: '#f0f0f0',
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 11, color: '#999', cursor: 'help',
                      }}>?</span>
                    </Tooltip>
                  </Space>
                }
                valuePropName="checked"
              >
                <Switch
                  checkedChildren={<><EyeOutlined /> Visible sur Home</>}
                  unCheckedChildren={<><EyeInvisibleOutlined /> Masqué de Home</>}
                  style={{ minWidth: 140 }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          {/* REMISE */}
          <Card size="small" title={<span><PercentageOutlined style={{ color: '#1890ff', marginRight: 8 }} />Gestion de la Remise Annuelle</span>} style={{ marginBottom: 16 }}>
            <Form.Item name="annualDiscountRate" label="Pourcentage de remise annuelle">
              <div style={{ marginBottom: 16 }}>
                <div style={{ marginBottom: 12 }}>
                  <Text strong>Remises courantes :</Text>
                  <div style={{ marginTop: 8 }}>
                    <Space wrap>
                      {commonDiscounts.map(d => (
                        <Button key={d} size="small" type={discountValue === d ? 'primary' : 'default'}
                          onClick={() => applyCommonDiscount(d)} style={{ borderRadius: 16, minWidth: 50 }}>
                          {d}%
                        </Button>
                      ))}
                    </Space>
                  </div>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <Text strong>Réglage précis :</Text>
                  <div style={{ padding: '0 8px' }}>
                    <Slider value={discountValue} onChange={handleDiscountChange} min={0} max={50} step={1}
                      marks={{ 0: '0%', 10: '10%', 20: '20%', 30: '30%', 40: '40%', 50: '50%' }}
                      tooltip={{ formatter: v => `${v}%` }} />
                  </div>
                </div>
                <InputNumber style={{ width: '100%' }} value={discountValue} onChange={handleDiscountChange}
                  min={0} max={95} step={1} precision={1} placeholder="0"
                  formatter={v => `${v}%`} parser={v => v.replace('%', '')} />
              </div>
            </Form.Item>

            {form.getFieldValue('price') && discountValue > 0 && (
              <Alert type="info" showIcon message={
                <div>
                  <div><strong>Impact de la remise sur le prix annuel :</strong></div>
                  <div style={{ marginTop: 4 }}>
                    <Text>Prix annuel normal : </Text>
                    <Text delete>{form.getFieldValue('currency') || '$'}{(form.getFieldValue('price') * 12).toLocaleString('fr-FR')}</Text>
                  </div>
                  <div>
                    <Text>Prix avec remise : </Text>
                    <Text strong style={{ color: '#52c41a' }}>{form.getFieldValue('currency') || '$'}{calculateDiscountedPrice().discountedPrice.toLocaleString('fr-FR')}</Text>
                  </div>
                  <div>
                    <Text>Économie : </Text>
                    <Text strong style={{ color: '#fa541c' }}>{form.getFieldValue('currency') || '$'}{calculateDiscountedPrice().savings.toLocaleString('fr-FR')}</Text>
                  </div>
                </div>
              } style={{ marginTop: 12 }} />
            )}
          </Card>

          {/* FEATURES */}
          <div style={{ marginBottom: 16 }}>
            <Title level={5}>Fonctionnalités</Title>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
              <Input value={newFeature} onChange={e => setNewFeature(e.target.value)}
                placeholder="Ajouter une fonctionnalité" onPressEnter={addFeature} />
              <Button type="primary" icon={<PlusOutlined />} onClick={addFeature} disabled={!newFeature.trim()} />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {features.map((f, i) => (
                <Tag key={i} closable onClose={() => removeFeature(i)} style={{ marginBottom: 4 }}>{f}</Tag>
              ))}
            </div>
          </div>

          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <Space>
              <Button onClick={() => setModalVisible(false)} disabled={submitting}>Annuler</Button>
              <Button type="primary" htmlType="submit" loading={submitting} disabled={submitting}>
                {editingPlan ? 'Modifier' : 'Créer'}
              </Button>
            </Space>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default PlanManager;